import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation } from "react-i18next";

interface IParams {
    currentProviderName: string;
}

export const CurrentProvider = (props: IParams) => {
    const { t } = useTranslation("portin");
    const { currentProviderName } = props;

    return (
        <div>
            <Typography color="textSecondary">{t("currentProvider")}</Typography>
            <Typography style={{ marginTop: "10px" }} variant="body1">
                {currentProviderName}
            </Typography>
        </div>
    );
};
